import React from "react";
import Sidebar from "../Dashboard/sidebar";
import AnalysisHeader from "../Dashboard/analysisHeader";
import { MdOutlineCampaign, MdRemoveRedEye } from "react-icons/md";

const GNACapacityListing = () => {
  return (
    <>
      <div className="full-screen-bg">
        <Sidebar />
        <section className="dashboard-area">
          <AnalysisHeader />
          <div className="row g-0 shadow border-1 mb-3  bg-light">
            <div className=" col-md-3">
              <div className="listing-col-bg">
                <div className="listing-col-header">Capacity Listing</div>
                <div className="capacity_listing_bg">
                  <div className="d-flex align-items-center justify-content-between">
                    <h6>C4_SEP1423_SEP1723</h6>
                    <div><MdOutlineCampaign /></div>
                  </div>
                  <div className="dashboard-slot dashboard-slot-date-time my-2">
                    <div>
                      <div>14-Sep-2023</div>
                      <div>12:25 PM</div>
                    </div>
                    <div>-</div>
                    <div>
                      <div>17-Sep-2023</div>
                      <div>04:30 PM</div>
                    </div>
                  </div>
                  <div className="testfortest">
                    <div className="energy-cost-unit-box">
                      <div className="energy-cost-unit-box-content">
                        Energy
                        <input type="text" name="Energy" className="energy-cost-unit-field-content" placeholder="9 MW" />
                      </div>
                      <div className="energy-cost-unit-box-content">
                        Cost Ex-bus
                        <input type="text" name="Energy" className="energy-cost-unit-field-content" placeholder="₹ 7" />
                      </div>
                    </div>
                    <div className="c-icons-group">
                      <div><i className='fa fa-pencil c-icons'></i></div>
                      <div><i className='fa fa-list c-icons-2'></i></div>
                    </div>
                  </div>
                  <div className="small mt-2">Expires on 27-Sep-2023 05:31 PM</div>
                </div>
              </div>
            </div>
            <div className=" col-md-5">
              <div className="listing-col-bg">
                <div className="listing-col-header">Connections Placed</div>
                <div className="capacity_listing_bg">
                  <div className="bids_placed_cname">Company 1<br /> CL_24MAR_27MAR - 3MW/10 INR <MdRemoveRedEye size={30} className="bids_place_view_icons" /> </div>
                  <div className="bids_placed_cname">Company 2<br /> CL_24MAR_27MAR - 3MW/10 INR <MdRemoveRedEye size={30} className="bids_place_view_icons" /></div>
                  <div className="bids_placed_cname">Company 3<br /> CL_24MAR_27MAR - 3MW/10 INR <MdRemoveRedEye size={30} className="bids_place_view_icons" /></div>
                </div>
              </div>
            </div>
            <div className=" col-md-4">
              <div className="listing-col-bg">
                <div className="listing-col-header">Connections Received</div>
                <div className="capacity_listing_bg">
                  <div className="bids_placed_cname">Company AB<br /> CL_24MAR_27MAR - 3MW/10 INR  </div>
                  <div className="bids_placed_cname">Company YT<br /> CL_24MAR_27MAR - 3MW/10 INR </div>
                  <div className="bids_placed_cname">Company LT<br /> CL_24MAR_27MAR - 3MW/10 INR </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row g-0 shadow border-1 mb-3 bg-light">
            <div className=" col-md-3">
              <div className="listing-col-bg">
                <div className="listing-col-header">Capacity Listing</div>
                <div className="capacity_listing_bg">
                  <div className="d-flex align-items-center justify-content-between">
                    <h6>C4_SEP1423_SEP1723</h6>
                    <div><MdOutlineCampaign /></div>
                  </div>
                  <div className="dashboard-slot dashboard-slot-date-time my-2">
                    <div>
                      <div>14-Sep-2023</div>
                      <div>12:25 PM</div>
                    </div>
                    <div>-</div>
                    <div>
                      <div>17-Sep-2023</div>
                      <div>04:30 PM</div>
                    </div>
                  </div>
                  <div className="testfortest">
                    <div className="energy-cost-unit-box">
                      <div className="energy-cost-unit-box-content">
                        Energy
                        <input type="text" name="Energy" className="energy-cost-unit-field-content" placeholder="9 MW" />
                      </div>
                      <div className="energy-cost-unit-box-content">
                        Cost Ex-bus
                        <input type="text" name="Energy" className="energy-cost-unit-field-content" placeholder="₹ 7" />
                      </div>
                    </div>
                    <div className="c-icons-group">
                      <div><i className='fa fa-pencil c-icons'></i></div>
                      <div><i className='fa fa-list c-icons-2'></i></div>
                    </div>
                  </div>
                  <div className="small mt-2">Expires on 27-Sep-2023 05:31 PM</div>
                </div>
              </div>
            </div>
            <div className=" col-md-5">
              <div className="listing-col-bg">
                <div className="listing-col-header">Connections Placed</div>
                <div className="capacity_listing_bg">
                  <div className="bids_placed_cname">Company 1<br /> CL_24MAR_27MAR - 3MW/10 INR <MdRemoveRedEye size={30} className="bids_place_view_icons" /> </div>
                  <div className="bids_placed_cname">Company 2<br /> CL_24MAR_27MAR - 3MW/10 INR <MdRemoveRedEye size={30} className="bids_place_view_icons" /></div>
                  <div className="bids_placed_cname">Company 3<br /> CL_24MAR_27MAR - 3MW/10 INR <MdRemoveRedEye size={30} className="bids_place_view_icons" /></div>
                </div>
              </div>
            </div>
            <div className=" col-md-4">
              <div className="listing-col-bg">
                <div className="listing-col-header">Connections Received</div>
                <div className="capacity_listing_bg">
                  <div className="bids_placed_cname">Company AB<br /> CL_24MAR_27MAR - 3MW/10 INR  </div>
                  <div className="bids_placed_cname">Company YT<br /> CL_24MAR_27MAR - 3MW/10 INR </div>
                  <div className="bids_placed_cname">Company LT<br /> CL_24MAR_27MAR - 3MW/10 INR </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row g-0 shadow border-1 mb-3 bg-light">
            <div className=" col-md-3">
              <div className="listing-col-bg">
                <div className="listing-col-header">Capacity Listing</div>
                <div className="capacity_listing_bg">
                  <div className="d-flex align-items-center justify-content-between">
                    <h6>C4_SEP1423_SEP1723</h6>
                    <div><MdOutlineCampaign /></div>
                  </div>
                  <div className="dashboard-slot dashboard-slot-date-time my-2">
                    <div>
                      <div>14-Sep-2023</div>
                      <div>12:25 PM</div>
                    </div>
                    <div>-</div>
                    <div>
                      <div>17-Sep-2023</div>
                      <div>04:30 PM</div>
                    </div>
                  </div>
                  <div className="testfortest">
                    <div className="energy-cost-unit-box">
                      <div className="energy-cost-unit-box-content">
                        Energy
                        <input type="text" name="Energy" className="energy-cost-unit-field-content" placeholder="9 MW" />
                      </div>

                      <div className="energy-cost-unit-box-content">
                        Cost Ex-bus
                        <input type="text" name="Energy" className="energy-cost-unit-field-content" placeholder="₹ 7" />
                      </div>
                    </div>
                    <div className="c-icons-group">
                      <div><i className='fa fa-pencil c-icons'></i></div>
                      <div><i className='fa fa-list c-icons-2'></i></div>
                    </div>
                  </div>
                  <div className="small mt-2">Expires on 27-Sep-2023 05:31 PM</div>
                </div>
              </div>
            </div>
            <div className=" col-md-5">
              <div className="listing-col-bg">
                <div className="listing-col-header">Connections Placed</div>
                <div className="capacity_listing_bg">
                  <div className="bids_placed_cname">Company 1<br /> CL_24MAR_27MAR - 3MW/10 INR <MdRemoveRedEye size={30} className="bids_place_view_icons" /> </div>
                  <div className="bids_placed_cname">Company 2<br /> CL_24MAR_27MAR - 3MW/10 INR <MdRemoveRedEye size={30} className="bids_place_view_icons" /></div>
                  <div className="bids_placed_cname">Company 3<br /> CL_24MAR_27MAR - 3MW/10 INR <MdRemoveRedEye size={30} className="bids_place_view_icons" /></div>
                </div>
              </div>
            </div>
            <div className=" col-md-4">
              <div className="listing-col-bg">
                <div className="listing-col-header">Connections Received</div>
                <div className="capacity_listing_bg">
                  <div className="bids_placed_cname">Company AB<br /> CL_24MAR_27MAR - 3MW/10 INR  </div>
                  <div className="bids_placed_cname">Company YT<br /> CL_24MAR_27MAR - 3MW/10 INR </div>
                  <div className="bids_placed_cname">Company LT<br /> CL_24MAR_27MAR - 3MW/10 INR </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default GNACapacityListing;
